module.exports = __webpack_public_path__ + "967aaa02f99bb180dc331bc4dbdae98b.png";